import {ViewController} from "data/types/structure";
import {action, makeAutoObservable, observable} from "mobx";
import {inject, injectable} from "inversify";
import {ILeagueUser} from "data/types/entities";
import {Bindings} from "data/constants/bindings";
import type {ILeaguesStore} from "data/stores/leagues/leagues.store";
import type {IUser, IUserStore} from "data/stores/user/user.store";
import type {Empty} from "data/types/generics";

interface IParams {
	leagueId: number;
}

export interface IManageTableController extends ViewController<IParams> {
	get isLoading(): boolean;
	get users(): ILeagueUser[];
	get user(): IUser | undefined;
	get nextPage(): boolean;
	get leagueStarted(): boolean;

	loadMore: () => void;
	removeUser: (userId: number) => void;
}

@injectable()
export class ManageTableController implements IManageTableController {
	@observable private _leagueId: Empty<number>;
	constructor(
		@inject(Bindings.LeaguesStore) private _leaguesStore: ILeaguesStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}

	@observable private _isLoading: boolean = false;

	get isLoading(): boolean {
		return this._leaguesStore.isLoading;
	}

	get users(): ILeagueUser[] {
		return this._leaguesStore.leagueUsers;
	}

	get user(): IUser | undefined {
		return this._userStore.user;
	}

	get nextPage(): boolean {
		return this._leaguesStore.loadMoreMapper["leagueUsers"];
	}

	get leagueStarted(): boolean {
		return this._leaguesStore?.selectedLeague?.status !== "scheduled";
	}

	dispose(): void {
		return;
	}

	@action
	public loadMore = (): void => {
		void this._leaguesStore.fetchLeagueUsersLoadMore(this._leagueId);
	};

	@action
	public removeUser = (userId: number): void => {
		void this._leaguesStore.showRemoveFromLeagueModal(userId);
	};

	init(param: IParams): void {
		this._leagueId = param.leagueId;
		void this._leaguesStore.fetchLeagueUsers(this._leagueId);
	}
}
